import { gatewayServices } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import { ZSample2Settings, zSample2Settings } from "./ZSample2Settings";
import { zSample2, ZSample2, zSample2Row, ZSample2Row } from "./ZSample2";

const urlSample2 = (path: string) =>
  gatewayServices(`/sample-service/v2/api${path}`);

export const loadSample2Settings = async (objectId: ZUid) => {
  const resp = await rest.get(urlSample2("/settings"), {
    params: { objectId },
  });
  return zSample2Settings.parse(resp.data);
};

export const saveSample2Settings = async (
  objectId: ZUid,
  serviceId: ZUid,
  data: ZSample2Settings,
) => {
  await rest.put(urlSample2("/settings"), data, {
    params: { objectId, serviceId },
  });
};

export const loadSample2 = async (
  sampleRoundEntityId: ZUid,
): Promise<ZSample2> => {
  const resp = await rest.get(urlSample2("/sample"), {
    params: { sampleRoundEntityId },
  });
  return zSample2.parse(resp.data);
};

export const updateSample2Row = async (
  row: ZSample2Row,
  fieldType: "actualValue" | "newValue",
): Promise<ZSample2Row> => {
  const resp = await rest.put(urlSample2("/row"), row, {
    params: { fieldType },
  });
  return zSample2Row.parse(resp.data);
};

export const updateSample2POMs = async (ids: ZUid[]): Promise<void> => {
  await rest.put(urlSample2("/row/mc"), ids);
};
